// extracted by mini-css-extract-plugin
export default {"serverSide":"ServiceSideMaintenance_serverSide__uAbKz","mainContent":"ServiceSideMaintenance_mainContent__pz0JW","btns":"ServiceSideMaintenance_btns__xEs57"};